import React from 'react';

import { DashboardProps } from './Dashboard.props';

import DashboardView from './Dashboard.view';

const DashboardContainer = (props: DashboardProps) => {
  return <DashboardView />;
};

export default DashboardContainer;
